import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	errorDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.incidents-step.error-description-non-final',
		defaultMessage:
			"We've bumped into an issue while copying incidents. Please get in touch with the Atlassian support team for help.",
		description: 'Incidents step error description',
	},
	contactAtlassianSupportButtonNonFinal: {
		id: 'eoc-changeboarding.transition-home.incidents-step.contact-atlassian-support-button-non-final',
		defaultMessage: 'Contact Atlassian support',
		description: 'Incidents step contact Atlassian support button',
	},
	loadingTitleNonFinal: {
		id: 'eoc-changeboarding.transition-home.incidents-step.loading-title-non-final',
		defaultMessage: "We're copying your Opsgenie incidents to Jira Service Management",
		description: 'Incidents step loading title',
	},
	loadingDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.incidents-step.loading-description-non-final',
		defaultMessage:
			"Your Opsgenie incidents, linked alerts, and relevant data like PIRs are being copied to a new service project in Jira Service Management. Once it's complete, you'll be able to manage your incidents directly in Jira Service Management.",
		description: 'Incidents step loading description',
	},
	taskOneDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.incidents-step.task-one-description-non-final',
		defaultMessage: `We've copied your Opsgenie incidents, linked alerts, and relevant data like PIRs to a new service project named **Opsgenie Migrated Incidents** in Jira Service Management, using the Incidents issue type. They'll now look and work the same way other issues do in Jira, with a more tailored experience for incident management.\n
Go on, take a look.`,
		description: 'Incidents step task one description',
	},
	taskOneButtonNonFinal: {
		id: 'eoc-changeboarding.transition-home.incidents-step.task-one-button-non-final',
		defaultMessage: 'View your incidents in Jira',
		description: 'Incidents step task one button',
	},
	taskTwoDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.incidents-step.task-two-description-non-final',
		defaultMessage:
			"We've made incident statuses and priorities simpler in Jira Service Management. Here's the mapping between Opsgenie and Jira's statuses and priorities:",
		description: 'Incidents step task two description',
	},
	taskThreeDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.incidents-step.task-three-description-non-final',
		defaultMessage: `These incident fields aren't copied from Opsgenie to Jira Service Management:\n
- Actions
- Responder roles
- Stakeholder filters
- Stakeholder templates
`,
		description: 'Incidents step task three description',
	},
	taskFourDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.incidents-step.task-four-description-non-final',
		defaultMessage: `We've copied your existing Opsgenie incidents and PIRs to Jira Service Management. It's recommend that you create and manage your incidents and PIRs directly in Jira Service Management from now on, as it's easier and more efficient.\n
If you create new incidents and PIRs in Opsgenie, you'll get only one chance to copy them to Jira Service Management.`,
		description: 'Incidents step task one button',
	},
	taskFourConfirmationNonFinal: {
		id: 'eoc-changeboarding.transition-home.incidents-step.task-four-confirmation-non-final',
		defaultMessage: 'I understand I can copy Opsgenie incidents only once',
		description: 'Incidents step task one button',
	},
	taskFourCopyButtonNonFinal: {
		id: 'eoc-changeboarding.transition-home.incidents-step.task-four-copy-button-non-final',
		defaultMessage: 'Copy Opsgenie incidents to Jira',
		description: 'Incidents step task one button',
	},
	taskFourDescriptionSuccessNonFinal: {
		id: 'eoc-changeboarding.transition-home.incidents-step.task-four-description-success-non-final',
		defaultMessage: `You successfully copied all your incidents to Jira Service Management.\n
If you need to copy any new incidents and PIRs again, get in touch with Atlassian Support team. [Contact Atlassian support](https://support.atlassian.com/contact/#/)`,
		description: 'Incidents step three one description',
	},
});
